<article class="widget-card card">
  <header class="widget-header">
    <h2 class="widget-title">{{ titleKey | translate }}</h2>
  </header>

  <div class="widget-body">
    <ng-content />
  </div>
</article>
